<script>
import LegoTooltip from "@/components/Lego/LegoTooltip.vue";
import InputAutoGrow from "@/components/Lego/InputAutoGrow";
import LegoProgressBaWithCompleted from "@/components/Lego/LegoProgressBarWithCompleted.vue";
import CreatorColumns from "@/components/Lego/CreatorColumns.vue";
export default {
  props: {
    boardId: {
      required: true,
    },
  },
  components: {
    CreatorColumns,
    LegoTooltip,
    InputAutoGrow,
    LegoProgressBaWithCompleted,
  },
  data() {
    return {
      inputSearch: "",
      isFocusText: false,
      titleCopy: "",
      waiting: false,
      searchTimeout: null,
      isSearching: false,
      searchCompleted: false,
    };
  },
  watch: {
    inputSearch(newVal) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        if (newVal.trim() !== "") {
          //this.isSearching = true;
          this.searchCompleted = false;
          //this.performSearch();
        } else {
          // Solo resetear si había una búsqueda previa
          if (this.searchCompleted || this.isSearching) {
            this.resetSearch();
          }
        }
      }, 500);
    },
  },

  computed: {
    board() {
      return this.$store.state.lego.board;
    },
    columns() {
      if (this.board.paginatedColumns.items) {
        // Filtrar columnas que no tengan id (columnas de inicialización)
        return this.board.paginatedColumns.items.filter(
          (column) => column.id !== null
        );
      } else {
        return [];
      }
    },
    title() {
      return this.board.title;
    },
    userLoggedIn() {
      return this.$store.getters.userLoggedIn;
    },
    isTemplate() {
      return this.board.isTemplate;
    },
    roleLevel() {
      return this.$store.state.lego.currencyRole.level;
    },
    loadingColumns() {
      return this.$store.state.lego.loadingColumns;
    },
    totalColumns() {
      return this.board.paginatedColumns.total;
    },
    columnsActuales() {
      return this.$store.state.lego.columnsActuales;
    },
    hasSearchResults() {
      return (
        this.inputSearch.trim() &&
        this.searchCompleted &&
        this.columns.length > 0
      );
    },
    isSkeleton() {
      return this.$store.state.lego.isSkeleton;
    },
    showAllTasks() {
      return this.$store.state.lego.showAllTasks;
    },
    isDeletingBoard() {
      return this.$store.getters["lego/getIsDeletingBoard"];
    },
  },
  mounted() {
    this.$watch(
      () => this.title,
      () => {
        const headerInput = document.querySelector(".header-input");
        headerInput.value = this.title;
        this.parentDataSet({ target: headerInput });
      }
    );
  },
  methods: {
    async performSearch() {
      try {
        this.isSearching = true;
        this.searchCompleted = false;

        this.$store.commit("lego/setSearchOnly", {
          searchTerm: this.inputSearch.trim(),
        });
        this.$store.commit("lego/setBoard");
        await this.$store.dispatch("lego/getAndSetBoardDeep", {
          boardId: this.boardId,
          personaId: this.userLoggedIn.id,
          loadAllColumns: this.showAllTasks,
          searchTerm: this.inputSearch.trim(),
          limit: 5,
        });
      } finally {
        this.isSearching = false;
        this.searchCompleted = true;
      }
    },
    async resetSearch() {
      this.inputSearch = "";
      this.isSearching = false;
      this.searchCompleted = false;
      this.$store.commit("lego/setBoard");
      await this.$store.dispatch("lego/getAndSetBoardDeep", {
        boardId: this.boardId,
        personaId: this.userLoggedIn.id,
        loadAllColumns: this.showAllTasks,
        limit: 5,
      });
    },
    handleKeyPress(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        if (this.inputSearch.trim() !== "") {
          this.performSearch();
        }
      }
    },
    async toggleShowAllTasks() {
      const newValue = !this.showAllTasks;
      console.log("Toggle showAllTasks:", this.showAllTasks, "->", newValue);

      // Limpiar las columnas antes de cambiar el filtro
      this.$store.commit("lego/clearColumns");

      // Activar el skeleton
      this.$store.commit("lego/setSkeleton", true);

      this.$store.commit("lego/setShowAllTasks", newValue);
      await this.$store.dispatch("lego/getAndSetBoardDeep", {
        boardId: this.boardId,
        personaId: this.userLoggedIn.id,
        loadAllColumns: newValue,
      });
    },
    async deleteBoard() {
      try {
        const result = await this.$store.dispatch(
          "lego/deleteBoard",
          this.board
        );
        // Si la eliminación fue exitosa, redirigir a la página de tableros
        if (result === true) {
          this.$router.push({ name: "TusTableros" });
        }
      } catch (error) {
        // Si hay un error, no hacer nada (el usuario canceló o hubo un problema)
        console.log("Eliminación cancelada o error:", error);
      }
    },
    async cloneBoard() {
      this.waiting = true;
      const response = await this.$store.getters.fetchPost({
        path: `lego/CloneBoardDeepById/${this.board.id}/${this.userLoggedIn.id}`,
      });
      // const result = await response.json()
      this.waiting = false;
      if (response.ok) {
        this.$toast.success("Tablero copiado exitosamente", {
          timeout: 3000,
          position: "top-right",
        });
        this.$router.push({ name: "TusTableros" });
      } else {
        this.$toast.error("Error al copiar el tablero", {
          timeout: 3000,
          position: "top-right",
        });
      }
    },
    async createPlantilla() {
      this.waiting = true;
      const response = await this.$store.getters.fetchPost({
        path: `lego/CreatePlantillaDeepById/${this.board.id}/${this.titleCopy}/${this.userLoggedIn.id}`,
      });
      this.waiting = false;
      if (response.ok) {
        this.$toast.success("Plantilla creada exitosamente", {
          timeout: 3000,
          position: "top-right",
        });
        this.$router.push({ name: "TusTableros" });
      } else {
        this.$toast.error("Error al crear la plantilla", {
          timeout: 3000,
          position: "top-right",
        });
      }
    },
    async getDeepInfo() {
      const response = await this.$store.getters.fetchGet({
        path: `lego/BoardDeepById/${this.board.id}`,
      });
      const result = await response.json();
      console.log(result);
    },
    parentDataSet(ev) {
      ev.target.parentNode.dataset.value = ev.target.value;
    },
    focusOnHeaderTitle() {
      const headerInput = document.querySelector(".header-input");
      headerInput.focus();
    },
    updateTitleBoard(ev) {
      const card = {
        title: ev.target.value,
        id: this.boardId,
      };
      this.$store.dispatch("lego/setBoardTitle", card);
    },
    async clonePlantilla() {
      this.waiting = true;
      const response = await this.$store.getters.fetchPost({
        path: `lego/CreatePlantillaFromABoard/${this.board.id}/${this.userLoggedIn.id}`,
      });
      this.waiting = false;
      // try - catch
      if (response.ok) {
        this.$toast.success("Plantilla copiada exitosamente", {
          timeout: 3000,
          position: "top-right",
        });
        this.$router.push({ name: "TusTableros" });
      } else {
        this.$toast.error("Error al copiar la plantilla", {
          timeout: 3000,
          position: "top-right",
        });
      }
    },
    createColumn(column) {
      // Seria bueno agregar un loader congelando la vista hasta que se cree la columna.
      column.LegoBoardId = this.board.id;
      console.log(column);
      this.$store.dispatch("lego/addColumn", column);
    },
  },
};
</script>

<template>
  <header class="header">
    <div class="row header-top">
      <div class="col-12 col-md-7 d-flex align-items-center">
        <!-- back btn -->
        <div
          v-b-tooltip.hover
          title="Regresar"
          class="arrow-nav lego"
          @click="$router.back()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="27"
            viewBox="0 0 1024 1024"
          >
            <path
              d="M338.752 104.704a64 64 0 0 0 0 90.496l316.8 316.8l-316.8 316.8a64 64 0 0 0 90.496 90.496l362.048-362.048a64 64 0 0 0 0-90.496L429.248 104.704a64 64 0 0 0-90.496 0"
            />
          </svg>
        </div>
        <InputAutoGrow
          v-show="title"
          v-model="title"
          @blur="updateTitleBoard"
        />

        <b-skeleton v-show="isSkeleton && !title" width="250px"></b-skeleton>
      </div>
      <div
        class="col-12 col-md-2 d-flex align-items-center justify-content-end"
      >
        <slot></slot>
        <LegoTooltip
          v-if="!isTemplate && roleLevel <= 3"
          position="bottom-end"
          id="opcionesTableroLegos"
        >
          <span @click="focusOnHeaderTitle" v-if="roleLevel < 3"
            >Editar nombre del tablero</span
          >
          <RouterLink
            :to="{ name: 'TableroColaboradores' }"
            v-if="roleLevel < 3"
          >
            <span> Colaboradores </span>
          </RouterLink>

          <!-- filtrar tareas -->
          <span v-if="roleLevel === 3" @click="toggleShowAllTasks">
            <i class="fas fa-spinner fa-spin" v-if="loadingColumns"></i>
            {{
              showAllTasks
                ? "Mostrar solo mis tareas"
                : "Mostrar todas las tareas"
            }}
          </span>

          <LegoTooltip
            position="left-start"
            class="cancel-default-styles"
            v-if="!isTemplate && roleLevel < 3"
          >
            <template #button>
              <span>Copiar tablero </span>
            </template>
            <form @submit.prevent="cloneBoard">
              <header class="mb-2">
                <p>Copiar tablero</p>
              </header>
              <div class="body-tp">
                <p>
                  El nuevo tablero se llamará "{{ `${title} (Copia)` }}".
                  <br />
                  Al copiarlo, perderás los colaboradores y las fechas se
                  restablecerán.
                </p>
                <div class="mt-2">
                  <vs-button :loading="waiting" class="m-0">Copiar</vs-button>
                </div>
              </div>
            </form>
          </LegoTooltip>

          <LegoTooltip
            position="left-start"
            class="cancel-default-styles"
            v-if="isTemplate && roleLevel < 3"
          >
            <template #button>
              <span>Copiar Plantilla</span>
            </template>
            <form @submit.prevent="clonePlantilla">
              <header class="mb-2">
                <p>Copiar Plantilla</p>
              </header>
              <div class="body-tp">
                <p>
                  La nueva plantilla se llamará "{{ `${title} (Plantilla)` }}".
                  <br />
                  Al copiarlo, perderás los colaboradores y las fechas se
                  restablecerán.
                </p>
                <div class="mt-2">
                  <vs-button :loading="waiting" class="m-0">Copiar</vs-button>
                </div>
              </div>
            </form>
          </LegoTooltip>

          <LegoTooltip
            position="left-start"
            class="cancel-default-styles"
            v-if="!isTemplate && roleLevel < 3"
          >
            <template #button>
              <span>Crear plantilla</span>
            </template>
            <form @submit.prevent="clonePlantilla">
              <header class="mb-2">
                <span>Crear plantilla</span>
              </header>
              <div class="body-tp">
                <p>Se creará una plantilla a partir de este tablero.</p>
                <p>
                  La nueva plantilla se llamará "{{ `${title} (Plantilla)` }}".
                  <br />
                  Al copiarlo, perderás los colaboradores y las fechas se
                  restablecerán.
                </p>
                <div class="mt-2">
                  <vs-button :loading="waiting" class="m-0">Crear</vs-button>
                </div>
              </div>
            </form>
          </LegoTooltip>

          <span
            class="text-lego-danger"
            @click="deleteBoard"
            v-if="roleLevel === 1"
            :class="{ disabled: isDeletingBoard }"
            style="cursor: pointer"
          >
            <i
              v-if="isDeletingBoard"
              class="fas fa-spinner fa-spin"
              style="margin-right: 5px"
            ></i>
            {{ isDeletingBoard ? "Eliminando..." : "Eliminar tablero" }}
          </span>
        </LegoTooltip>
      </div>
    </div>
    <div class="header-bottom">
      <LegoProgressBaWithCompleted
        :total="board.totalCards"
        :completed="board.totalCardsComplete"
        mode="cards"
        id="barraProgresoTablero"
      />
      <div
        class="d-flex flex-column flex-md-row align-items-center justify-content-between mt-2"
        id="buscadorColumnasTablero"
      >
        <div class="d-flex align-items-center flex-wrap" style="gap: 1rem">
          <!-- buscador -->
          <div class="wrapper-input-text">
            <input
              v-model="inputSearch"
              @blur="isFocusText = false"
              @keypress="handleKeyPress"
              type="text"
              class="input"
              placeholder="Buscar..."
              ref="search"
              title="Busca en títulos de columnas, nombres de tareas y descripciones"
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              class="icon-search"
              @click="inputSearch.trim() !== '' ? performSearch() : null"
            >
              <path
                d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
              />
            </svg>
          </div>
          <CreatorColumns @createColumn="createColumn" v-if="roleLevel < 3" />
        </div>

        <!-- indicador de columnas -->
        <div
          class="header-indicator mt-2 mt-md-0"
          v-b-tooltip.hover
          :title="`${columns.length} de ${totalColumns} columnas${
            roleLevel === 3 ? ` (${!showAllTasks ? 'asignadas' : 'todas'})` : ''
          }`"
        >
          {{ columns.length }}/{{ totalColumns }}
          {{
            roleLevel === 3 ? `(${!showAllTasks ? "asignadas" : "todas"})` : ""
          }}
        </div>
      </div>

      <!-- Mensajes de búsqueda -->

      <div v-if="hasSearchResults" class="search-results-count">
        Se encontró {{ columns.length }}
        {{ columns.length === 1 ? "columna" : "columnas" }} con resultados
      </div>

      <div v-if="inputSearch.trim()" class="search-messages">
        <div v-if="isSearching" class="search-message">
          <i class="fas fa-spinner fa-spin"></i> Buscando...
        </div>
        <div
          v-else-if="searchCompleted && columns.length === 0"
          class="search-message"
        >
          No se encontraron resultados para "{{ inputSearch }}"
        </div>
      </div>
      <!--<b-skeleton v-show="isSkeleton" width="100%" height="10px"></b-skeleton>-->
    </div>
  </header>
</template>

<style scoped>
.header-indicator {
  text-align: right;
  opacity: 0.7;
  width: fit-content;
}
.wrapper-auto-grow {
  display: inline-grid;
  width: max-content;
}

.wrapper-auto-grow::after,
.wrapper-auto-grow .input-auto-grow {
  /* width: auto; */
  /* min-width: 1em; */
  grid-area: 1/2;
  font: inherit;
  padding: 0.5rem;
}

.wrapper-auto-grow::after {
  content: attr(data-value) "";
  visibility: hidden;
  white-space: pre-wrap;
}

.header {
  padding: 0.5rem 0;
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.5rem;
  font-size: 1.3rem;
}

.header-bottom {
  /* background-color: green; */
  width: 100%;
  margin: 0;
  padding: 0 1rem;
}

.body-tp {
  text-align: left;
}

.wrapper-input-text {
  width: 300px;
  font-size: 0.8rem;
  /* margin-bottom: 0.5rem; */
  border-collapse: collapse;
  padding-right: 8px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 1px 0px 0px rgba(0, 0, 0, 0.1);
  .dark & {
    box-shadow: 0 1px 0px 0px rgba(255, 255, 255, 0.1);
  }
}

.icon-search {
  width: 14px;
  fill: var(--lego-gris);
  cursor: pointer;
}

.input {
  border: none;
  padding: 5px 10px;
  background-color: transparent;
  box-sizing: border-box;
  color: black;
  .dark & {
    color: white;
  }
}

.input::placeholder {
  color: var(--lego-gris);
}
input.input {
  padding-bottom: 6px;
}

.search-messages {
  margin-top: 8px;
  text-align: left;
}

.search-message {
  padding: 4px 0;
  color: var(--lego-gris);
}

.search-message i {
  margin-right: 5px;
}

.search-message:last-child {
  color: var(--lego-gris-oscuro);
  font-style: italic;
}

.search-results-count {
  margin-top: 8px;
  color: var(--primary);
}

.text-lego-danger.disabled {
  opacity: 0.6;
  pointer-events: none;
}
</style>
